export default __webpack_public_path__ + "static/media/arcgis-enterprice-cloud-launch-kit.1ca13eac.svg";